<script>
    export let label = "";
    export let disabled = false;
</script>

<button class="button" {disabled} on:change on:input on:click>
    {label}
</button>

<style>
    button {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: 2px solid var(--fg-color);
        border-radius: 5px;
        background: transparent;
        cursor: pointer;
        font: inherit;
        font-weight: bold;
        text-align: center;
        color: inherit;
        background-color: inherit;
        padding: 7px 20px;
        margin: 0;
        width: 100%;
        transition: background-color 0.15s, border-color 0.15s;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
    }
    .button:hover,
    .button:focus {
        border: 2px solid var(--fg-color);
        color: var(--hover-fg-color);
        background-color: var(--hover-bg-color);
    }
    .button:disabled {
        border: 2px solid var(--darker-bg-color);
        background-color: var(--dark-bg-color);
        cursor: default;
    }
</style>
